import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Aviso } from "./styles"
import { faCircleCheck, faCircleExclamation, faCircleInfo, faCircleXmark, faInfo, faSkullCrossbones } from "@fortawesome/free-solid-svg-icons";

//PROPS
interface Props {
    children: React.ReactNode;
    type?: 'warning' | 'danger' | 'error' |'success' | 'info';
    style?: React.CSSProperties;
}

export const Warning: React.FC<Props> = ({ children, type, style }) => {

    function iconType() {
        switch (type) {
            case 'warning':
                return faCircleExclamation;
            case 'danger':
                return faSkullCrossbones;
            case 'error':
                return faCircleXmark;
            case 'success':
                return faCircleCheck;
            case 'info':
                return faCircleInfo;
            default:
                return faInfo;
        }
    }

    return (
        <Aviso data-type={type} style={style}>
            <FontAwesomeIcon icon={iconType()} />
            {children}
        </Aviso>
    )
}